// src/lexmail/angle2.js
import React, { useEffect, useRef, useState } from "react";
import { FiVolume2, FiVolumeX } from "react-icons/fi";
import MiniGLBViewer from "../pages/Spaceship";   // 如果路径不同自行调整

export default function Angle2({ children }) {
  const audioRef = useRef(null);
  const [muted, setMuted] = useState(true);
  const [volume, setVolume] = useState(0.15);

  useEffect(() => {
    const audio = new Audio("/sounds/mail.mp3"); // ★ 邮件感的背景音
    audio.loop = true;
    audio.volume = volume;
    audio.muted = muted;
    audioRef.current = audio;
    audio.play().catch(() => {});
    return () => { audio.pause(); audio.src = ""; };
  }, []);

  const toggleMute = () => {
    audioRef.current.muted = !audioRef.current.muted;
    setMuted(audioRef.current.muted);
  };
  const onVolume = e => {
    const v = +e.target.value;
    setVolume(v);
    audioRef.current.volume = v;
  };

  return (
    <div style={{ position: "relative", width: "100vw", height: "100vh", overflow: "hidden" }}>
      {/* 背景 iframe */}
      <div style={{ position: "fixed", top: 0, left: 0, width: "100vw", height: "100vh", zIndex: 0 }}>
        <style>{`
          .sketchfab-embed-wrapper {
            position: fixed;
            top: 0; left: 0;
            width: 100vw; height: 100vh;
            pointer-events: auto;
          }
          .sketchfab-embed-wrapper > iframe {
            width: 120%; height: 120%;
            transform: translate(-10%, -10%) scale(1.1);
            pointer-events: auto;
          }
        `}</style>
        <div className="sketchfab-embed-wrapper">
          <iframe
            title="galaxy"
            frameBorder="0"
            allow="autoplay; fullscreen; xr-spatial-tracking"
            src="https://sketchfab.com/models/56112ae2e55e45a4951362b323540349/embed?autostart=1&camera=0"
          />
        </div>
      </div>

      {/* 小模型，左下 20px */}
      <div style={{
        position: "fixed",
        bottom: "88px",
        left: "20px",
        width: 64,
        height: 64,
        zIndex: 150
      }}>
        <MiniGLBViewer url="/models/spaceship.glb" />
      </div>

      {/* 音量控件，左下 20px */}
      <div style={{
        position: "fixed",
        bottom: "20px",
        left: "20px",
        display: "flex",
        gap: 8,
        zIndex: 200
      }}>
        <button
          onClick={toggleMute}
          style={{
            background: "rgba(0,0,0,0.35)",
            border: "none",
            borderRadius: 4,
            padding: 8,
            color: "#fff",
            cursor: "pointer"
          }}
        >
          {muted ? <FiVolumeX size={20}/> : <FiVolume2 size={20}/>}
        </button>
        <input
          type="range"
          min="0"
          max="1"
          step="0.01"
          value={muted ? 0 : volume}
          onChange={onVolume}
          style={{ width: 90 }}
        />
      </div>


    {/* —— UI 层 —— */}
      <div style={{
        position: "relative",
        zIndex: 100,
        width: "100%",
        height: "100%",
        pointerEvents: "none"   // 整个 UI 默认不拦截事件
      }}>
        {children}               // 直接渲染子组件
      </div>

    </div>
  );
}
